import Home from '../pages/home/Home';
import Search from '../pages/search/Search';
import ResultDetail from '../pages/result/ResultDetail';
import Profile from '../pages/profile/index';
import EasyLease from '../pages/about_easylease/EasyLease';
import SubscriptionSuccessful from '../pages/subscription_successful/SubscriptionSuccessful';
import Location from '../pages/locations/Location';
import HowItWorks from '../pages/how_it_works/HowItWorks';
import TermAndCondition from '../pages/trem_and_condition/TermAndCondition';
import CookiePolicy from '../pages/cookie_policy/CookiePolicy';
import FareWareAndTearpolicy from '../pages/fairware_and_tear_policy/FairwareAndTearPolicy';
import PravicyPolicy from '../pages/PrivicyPolicy/PrivacyPolicy';
import SolutionForBusiness from '../pages/solution_for_business/SolutionForBusiness';
import FeedBack from '../pages/feed_back/FeedBack';
import HowItWork from '../pages/how_it_works/HowItWorks';
import Faq from '../pages/faq/FAQ';
import RequestACallback from '../pages/request_a_callback/RequestACallBack';
import Sitemap from '../pages/sitemap/Sitemap';
import Contact from '../pages/contact/Contact';
import AboutYomafleet from '../pages/about_yomafleet/Yomafleet';
import Redirect from '../pages/verification/Redirect';
import PasswordReset from '../pages/reset-password/Reset';
import SubscriptionInfo from '../pages/subscription/Information';
import SubscriptionEmployee from '../pages/subscription/Employee';
import SubscriptionLicense from '../pages/subscription/Licese';
import SubscriptionIdentification from '../pages/subscription/Identification';
import SubscriptionPayment from '../pages/subscription/Payment';
import SubscriptionDelivery from '../pages/subscription/Delivery';
import SubscriptionContract from '../pages/subscription/Contract';
import SubscriptionDeclaration from '../pages/subscription/Declaration';
import VehicleDetail from '../pages/vehicle/Detail';
import Subscriptions from '../pages/subscriptions/Index';
// import PageNotFound from '../pages/error/PageNotFound';
// import SubscriptionHistoryDetail from '../pages/subscriptions/history/Index';
// import ChangePassword from '../pages/change-password/ChangePassword';
import CompanyRegistraion from '../pages/company_registration/registration';

const HOME = '/';
const SIGNIN = '/signin';
const SIGNUP = '/signup';
const BROWSE_CAR = '/vehicle';
const RESULT_DETAIL = '/result';
const SOLUTION_FOR_BUSINESS = '/solution/business';
const PROFILE = '/profile/detail';
const SUBSCRIPTION_INFO = '/subscription/information';
const SUBSCRIPTION_EMPLOYEE = '/subscription/employee';
const SUBSCRIPTION_LICENSE = '/subscription/license';
const SUBSCRIPTION_DECLARATION = '/subscription/declaration';
const SUBSCRIPTION_IDENTIFICATION = '/subscription/identification';
const SUBSCRIPTION_DELIVERY = '/subscription/delivery';
const SUBSCRIPTION_PAYMENT = '/subscription/payment';
const SUBSCRIPTION_CONTRACT = '/subscription/contract';
const EASYLEASE = '/easylease';
const SUBSCRIPTION_SUCCESSFUL = '/subscription/successful';
const LOCATIONS = '/locations';
const HOWITWORKS = '/how-it-works';
const TERM_AND_CONDITION = '/terms-and-conditions';
const COOKIE_POLICY = '/policy/cookies';
const FARE_WEAR_AND_TEAR_POLICY = '/fare-ware-and-tear';
const PRAVICY_AND_POLICY = '/privacy-policy';
const FEED_BACK = '/feed-back';
const HOW_IT_WORKS = '/how-it-works';
const FAQ = '/faq';
const REQUEST_A_CALLBACK = '/feedback';
const SITEMAP = '/sitemap';
const CONTACT = '/contactus';
const ABOUTYOMAFLEET = '/about-us';
const REDIRECT = '/redirect';
const PASSWORD_RESET = '/password/reset';
const VEHICLE_DETAIL = '/vehicles/:id';
const SUBSCRIPTIONS = '/subscriptions';
const SUBSCRIPTIONS_HISTORY_DETAIL = '/subscriptions/history/:id';
const COMPANY_REGISTRATION = '/company/registration';

const appRoutes = [
    {
        path: '/',
        exact: true,
        component: Home,
    },
    {
        path: SIGNIN,
        exact: false,
        component: Home,
    },
    {
        path: SIGNUP,
        exact: false,
        component: Home,
    },
    {
        path: BROWSE_CAR,
        exact: false,
        component: Search,
    },
    {
        path: PROFILE,
        exact: false,
        component: Profile,
    },
    {
        path: RESULT_DETAIL,
        exact: false,
        component: ResultDetail,
    },
    {
        path: EASYLEASE,
        exact: false,
        component: EasyLease,
    },
    {
        path: SUBSCRIPTION_SUCCESSFUL,
        exact: false,
        component: SubscriptionSuccessful,
    },
    {
        path: LOCATIONS,
        exact: false,
        component: Location,
    },
    {
        path: HOWITWORKS,
        exact: false,
        component: HowItWorks,
    },
    {
        path: TERM_AND_CONDITION,
        exact: false,
        component: TermAndCondition,
    },
    {
        path: COOKIE_POLICY,
        exact: false,
        component: CookiePolicy,
    },
    {
        path: FARE_WEAR_AND_TEAR_POLICY,
        exact: false,
        component: FareWareAndTearpolicy,
    },
    {
        path: PRAVICY_AND_POLICY,
        exact: false,
        component: PravicyPolicy,
    },
    {
        path: SOLUTION_FOR_BUSINESS,
        exact: false,
        component: SolutionForBusiness,
    },
    {
        path: FEED_BACK,
        exact: false,
        component: FeedBack,
    },
    {
        path: HOW_IT_WORKS,
        exact: false,
        component: HowItWork,
    },
    {
        path: FAQ,
        exact: false,
        component: Faq,
    },
    {
        path: REQUEST_A_CALLBACK,
        exact: false,
        component: RequestACallback,
    },
    {
        path: SITEMAP,
        exact: false,
        component: Sitemap,
    },
    {
        path: CONTACT,
        exact: false,
        component: Contact,
    },
    {
        path: ABOUTYOMAFLEET,
        exact: false,
        component: AboutYomafleet,
    },
    {
        path: REDIRECT,
        exact: false,
        component: Redirect,
    },
    {
        path: PASSWORD_RESET,
        exact: false,
        component: PasswordReset,
    },
    {
        path: SUBSCRIPTION_CONTRACT,
        exact: false,
        component: SubscriptionContract,
    },
    {
        path: SUBSCRIPTION_DECLARATION,
        exact: false,
        component: SubscriptionDeclaration,
    },
    {
        path: SUBSCRIPTION_DELIVERY,
        exact: false,
        component: SubscriptionDelivery,
    },
    {
        path: SUBSCRIPTION_IDENTIFICATION,
        exact: false,
        component: SubscriptionIdentification,
    },
    {
        path: SUBSCRIPTION_PAYMENT,
        exact: false,
        component: SubscriptionPayment,
    },
    {
        path: SUBSCRIPTION_EMPLOYEE,
        exact: false,
        component: SubscriptionEmployee,
    },
    {
        path: SUBSCRIPTION_INFO,
        exact: false,
        component: SubscriptionInfo,
    },
    {
        path: SUBSCRIPTION_LICENSE,
        exact: false,
        component: SubscriptionLicense,
    },
    {
        path: VEHICLE_DETAIL,
        exact: false,
        component: VehicleDetail,
    },
    {
        path: SUBSCRIPTIONS,
        exact: false,
        component: Subscriptions,
    },
    // {
    //     path: "*",
    //     exact: false,
    //     component: Home,
    // },
    {
        path: SUBSCRIPTIONS_HISTORY_DETAIL,
        exact: false,
    },
    {
        path: COMPANY_REGISTRATION,
        exact: false,
        component: CompanyRegistraion,
    },
];

// export default route;
export default appRoutes;

export {
    HOME,
    SIGNIN,
    SIGNUP,
    BROWSE_CAR,
    SOLUTION_FOR_BUSINESS,
    PROFILE,
    RESULT_DETAIL,
    EASYLEASE,
    SUBSCRIPTION_SUCCESSFUL,
    LOCATIONS,
    HOWITWORKS,
    TERM_AND_CONDITION,
    COOKIE_POLICY,
    FARE_WEAR_AND_TEAR_POLICY,
    PRAVICY_AND_POLICY,
    FEED_BACK,
    FAQ,
    REQUEST_A_CALLBACK,
    SITEMAP,
    CONTACT,
    ABOUTYOMAFLEET,
    REDIRECT,
    PASSWORD_RESET,
    SUBSCRIPTION_INFO,
    SUBSCRIPTION_EMPLOYEE,
    SUBSCRIPTION_DECLARATION,
    SUBSCRIPTION_PAYMENT,
    SUBSCRIPTION_CONTRACT,
    SUBSCRIPTION_DELIVERY,
    SUBSCRIPTION_LICENSE,
    SUBSCRIPTION_IDENTIFICATION,
    VEHICLE_DETAIL,
    SUBSCRIPTIONS,
    COMPANY_REGISTRATION,
    // CHANGE_PASSWORD,
};
